
<input [ngModel]="inputValue" [ngClass]="{datepicker: editClass}" (ngModelChange)="onValueChange($event)" [matDatepicker]="date" disabled="disabled" name="date"/>
<mat-datepicker-toggle style="position: relative; top: 7px; color: #8b8f9e; " [for]="date" [ngClass]="{'clr-white': editClass}"></mat-datepicker-toggle>
<mat-datepicker #date disabled="false"></mat-datepicker>
